import * as types from '../types/authTypes';
import { storeRemoveAccessToken } from 'lib/network/jwt-token-access';

export const signOutRequest = () => {
  storeRemoveAccessToken();
  return { type: types.SIGNOUT_REQUEST };
};
